//Evaluar si un valor es null or empty
const isNullOrZero = (val) => {
  return val === null || val === 0;
};

export default isNullOrZero;
